export default __webpack_public_path__ + "static/media/misc-books3-1440w.57d90228.png";